import {call, put, fork, select, take} from "redux-saga/effects";
import {getUserInfo} from "../../reducers/app";
import {cashInfo, accountInfo} from "../../reducers/account";
import API from "../../api/api";
import {CODES} from "../../constants";
import {toast} from "react-toastify";

function *changeFeeType(value:string): Generator<any, void, any> {
    let money: number = parseFloat(value)
    let account = yield select(accountInfo)
    if (account.orgCurrency === 'JPY') {
        money = Math.round(money)
    } else {
        money = parseFloat(money.toFixed(2))
    }
    yield put({type: 'SET_CASH_INFO', payload: money})
}

function *cashSubmit(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let cash = yield select(cashInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        withdrawAmt : cash.withdrawAmt
    }
    let resp = yield call(API.cashMoney, params)
    if (resp.code === CODES.SUCCESS) {
        toast.success(resp.msg)
        setTimeout(() => {
            window.location.reload()
        }, 1000)
    }
}

export function *getAccount(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5'
    }
    let resp = yield call(API.getAccount, params)
    if (resp.code === CODES.SUCCESS) {
        yield put({type: 'SET_ACCOUNT_INFO', payload: resp.data})
    }
}

export function * watchCashChange(): Generator<any, void, any> {
    while (true) {
        let {payload} = yield take('MONEY_GET')
        if(payload.key === 'change') {
            yield fork(changeFeeType, payload.object.value)
        }
        if(payload.key === 'submit') {
            yield fork(cashSubmit)
        }
    }
}
